<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{
          $t("Retail business management center")
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-rowr">
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              :placeholder="$t('Enter keywords to search')"
              @keyup.enter.native="handleSearch"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>{{ $t("Reset the displayed order list") }}</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        :element-loading-text="$t('Please wait')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div
                class="content_wrap flex-between"
                @click="handleDetail(item.id, item.openid)"
              >
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      {{ $t("Order number") }}：<span>{{ item.orderno }}</span>
                    </p>
                    <p>
                      {{ $t("Creation time") }}：<span>{{
                        item.createdate | formatDate
                      }}</span>
                    </p>
                    <p>
                      {{
                        item.ordertype == 60
                          ? $t("Third-party retail channel order")
                          : item.ordertypestr
                      }}
                    </p>
                    <p>
                      {{ $t("Sales specialist name") }}：<span>{{
                        item.salerstr
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Order area") }}：<span>{{
                        COUNTRY.countryname_e
                      }}</span>
                    </p>
                    <!-- <p>
                      {{ $t("Order source channel") }}：<span>{{
                        item.channelidstr
                      }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <div class="shop_name_num_item flex-rowl">
                      <p class="label">
                        {{ $t("Number of products in the order") }}：
                      </p>
                      <p>
                        <span>{{ item.totalNum }}</span>
                      </p>
                    </div>
                    <div class="shop_wrap">
                      <div
                        class="shop_item flex-rowl"
                        v-for="(itemChild, indexChild) in item.goods"
                        :key="indexChild"
                      >
                        <div class="img">
                          <el-image
                            style="width: 70px; height: 70px"
                            :src="itemChild.img"
                            fit="cover"
                          ></el-image>
                        </div>
                        <div class="content">
                          <p>
                            {{ $t("Product name") }}：<span>{{
                              itemChild.multilingualCommodityname
                            }}</span>
                          </p>
                          <p>
                            {{ $t("Quantity of products") }}：<span>{{
                              itemChild.num
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block">
                    <p>
                      {{ $t("Order audit status") }}：<span class="red">{{
                        item.ischeck == 0
                          ? $t("Pending review")
                          : item.ischeck == 1
                          ? $t("Approved")
                          : item.ischeck == 2
                          ? $t("Failed the audit")
                          : ""
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Refund/return application status") }}：<span
                        class="red"
                        >{{
                          item.isreturn === true
                            ? "YES"
                            : item.isreturn === false
                            ? "NO"
                            : $t("None")
                        }}</span
                      >
                    </p>
                    <p>
                      {{ $t("Refund/return processing status") }}：<span
                        class="red"
                        >{{
                          item.returnstate ? item.returnstate : $t("None")
                        }}</span
                      >
                    </p>
                    <p>
                      {{ $t("Order status") }}：<span class="red">{{
                        item.ordertalk == 1
                          ? $t("In progress")
                          : item.ordertalk == 2
                          ? $t("Completed")
                          : item.ordertalk == 3
                          ? $t("Closed")
                          : $t("None")
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Shipping Status") }}：<span class="red">{{
                        item.orderstate == "待发货"
                          ? $t("To be shipped")
                          : item.orderstate
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div
                  class="detail_icon"
                  @click="handleDetail(item.id, item.openid)"
                >
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          :description="$t('No data yet')"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringadd } from "../../../api/api";
import { getOrderListWeb } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cRetailOrderList",
  data() {
    return {
      loading: false,
      qyid: 180,
      screenList: [
        { txt: "全部", type: "", con: "" },
        { txt: "待审核", type: "ischeck", con: 0 },
        { txt: "审核通过", type: "ischeck", con: 1 },
        { txt: "审核不通过", type: "ischeck", con: 2 },
        { txt: "支付未完成", type: "paystate", con: 0 },
        { txt: "已支付完成", type: "paystate", con: 1 },
        { txt: "退费申请待审核", type: "returntalk", con: 1 },
        { txt: "退费申请不通过", type: "returntalk", con: 2 },
        { txt: "退款中", type: "orderstate", con: "已申请退费" },
        { txt: "已退款", type: "orderstate", con: "已退费" },
      ],
      select: "全部",
      dataList: [],
      listTotal: 0,
      type: "",
      params: {
        openid: "",
        ordertype: "", // 订单类型
        keyword: "",
        qyid: "",
        returntalk: "", // 退款状态
        ischeck: "", // 订单审核
        paystate: "", // 支付状态
        orderstate: "", // 订单状态
        pageindex: 1,
        pagesize: 15,
        currency_trans: '',
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "COUNTRY", "USERINFO"]),
  },
  created() {
    this.params.openid = this.$store.state.OPENID;
    this.params.currency_trans = this.USERINFO.countryExrateObj.id;
    this.getOrderListWeb();
  },
  methods: {
    handleMultilingualName(dataList, key1, key2, key3, key4) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v.multilingualCommodityname = v[key1];
        } else if (countryid == 8) {
          // 英文
          v.multilingualCommodityname = v[key2] ? v[key2] : v[key1];
        } else if (countryid == 2) {
          // 俄语
          v.multilingualCommodityname = v[key3]
            ? v[key3]
            : v[key2]
            ? v[key2]
            : v[key1];
        } else if (countryid == 4) {
          // 越语
          v.multilingualCommodityname = v[key4]
            ? v[key4]
            : v[key2]
            ? v[key2]
            : v[key1];
        }
      });
      return dataList;
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getOrderListWeb();
    },
    // 搜索
    handleSearch() {
      this.getOrderListWeb();
    },
    // 筛选
    handleScreen(item) {
      if (item.con == "" && item.type == "") {
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "ischeck") {
        this.params.ischeck = item.con;
        this.params.returntalk = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "returntalk") {
        this.params.returntalk = item.con;
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "paystate") {
        this.params.paystate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.orderstate = "";
      } else if (item.type == "orderstate") {
        this.params.orderstate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
      }
      this.select = item.txt;
      this.getOrderListWeb();
    },
    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.getOrderListWeb();
    },
    getOrderListWeb() {
      this.loading = true;
      getOrderListWeb(this.params).then((res) => {
        let newRes = res.list;
        newRes.forEach((v) => {
          if (v.goods.length > 0) {
            v.totalNum = 0;
            v.goods.forEach((v1) => {
              v.totalNum += v1.num;
            });
            this.handleMultilingualName(
              v.goods,
              "commodityname",
              "commodityname_e",
              "commodityname_y",
              "commodityname_m"
            );
          }
        });
        this.dataList = newRes;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    handleDetail(id, openid) {
      this.encryptstringadd("cRetailOrderDetail", {
        id,
        openid,
        type: "cRetailOrderList",
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning(this.$t("Opening soon"));
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .list_wrap {
    height: 60vh;
    overflow-y: scroll;
  }
  .main_container {
    .select_add {
      // p {
      //   &:last-child {
      //     margin-left: 49px;
      //   }
      // }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .red {
      color: #ee0032;
    }
  }
  .intro_box {
    .block {
      margin-right: 30px;
    }
    cursor: pointer;
    .shop_item {
      margin-bottom: 5px;
      font-size: 14px;
      align-items: flex-start;
      .img {
        margin-right: 10px;
      }
    }
  }
}
</style>